const NewDocument = (props: React.SVGProps<SVGSVGElement>) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 24 24"
        {...props}
    >
        <path
            fill-rule="evenodd"
            d="M13.75 16.75h-6.5v-1.5h6.5v1.5Zm2.976-4H7.25v-1.5h9.5v1.486a5.29 5.29 0 0 0-.024.014ZM14.207 19h-8.9a.294.294 0 0 1-.21-.096.294.294 0 0 1-.097-.211V5.308c0-.077.032-.147.096-.211A.294.294 0 0 1 5.308 5h13.384c.077 0 .148.033.212.097a.294.294 0 0 1 .096.211v6.715a5.547 5.547 0 0 1 1.5.068V5.308c0-.505-.175-.933-.525-1.283a1.745 1.745 0 0 0-1.283-.525H5.308c-.505 0-.933.175-1.283.525-.35.35-.525.778-.525 1.283v13.385c0 .505.175.932.525 1.282.35.35.778.525 1.283.525h9.582a5.472 5.472 0 0 1-.683-1.5ZM16.75 8.75h-9.5v-1.5h9.5v1.5Z"
            clip-rule="evenodd"
        />
        <path d="M18.39 20.524v-4.388l-1.686 1.687-.775-.776 3.016-3.015 3.015 3.015-.775.776-1.686-1.687v4.388H18.39Z" />
    </svg>
);

export default NewDocument;
